import React, { Fragment, FC, useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import ReCAPTCHA from 'react-google-recaptcha'
import { MultiLineStringInputViewModel } from '@sitecore-jss/sitecore-jss-forms'
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms/types'
import { UpdateCaptchaStatus } from '../../../ReduxImpl/actions/index'

export interface MultiLineStringInputViewModelCaptcha
  extends MultiLineStringInputViewModel {
  publicKey?: string
}
const ReCaptcha: FC<ValueFieldProps<MultiLineStringInputViewModelCaptcha>> = (
  props
) => {
  const { field } = props

  const dispatch = useDispatch()

  const [expired, setExpired] = useState(true)

  const publicKey = field.model.publicKey

  const onChange = (value: any): void => {
    if (value) {
      setExpired(false)
    } else {
      setExpired(true)
    }
  }

  useEffect(() => {
    dispatch(UpdateCaptchaStatus(expired))
  }, [expired])

  return (
    <Fragment>
      <script
        src="https://www.google.com/recaptcha/api.js"
        async
        defer
      ></script>
      <ReCAPTCHA sitekey={publicKey as any} onChange={onChange} />
    </Fragment>
  )
}

export default ReCaptcha
